import React from "react";

export function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = React.useState(() => {
        if (typeof window === "undefined") {
            return initialValue;
        }

        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const storedValueRef = React.useRef(storedValue);
    storedValueRef.current = storedValue;

    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValueRef.current) : value;
            storedValueRef.current = valueToStore;
            setStoredValue(valueToStore);

            if (typeof window !== "undefined") {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        } catch (error) {
            console.log(error);
        }
    };

    return [storedValue, setValue];
}
